"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _endpoints = require("./endpoints");
var dokdriveApi = {
  device: {
    /** @returns {Promise<string>} */hostname: function hostname() {
      return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var _yield$dokdrive$get, data;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _endpoints.dokdrive.get("/machine/name");
            case 2:
              _yield$dokdrive$get = _context.sent;
              data = _yield$dokdrive$get.data;
              return _context.abrupt("return", data.name);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
};
var _default = dokdriveApi;
exports["default"] = _default;